
import { Checkbox, Text, InlineGrid, InlineStack, Modal, Select, TextField, BlockStack, Avatar, Card, Icon, Link, Divider, Box, Tag, Banner } from "@shopify/polaris";
import { PersonIcon, SmileyJoyIcon, DiscountIcon, PlayIcon, LogoTiktokIcon, LogoYoutubeIcon, LogoInstagramIcon } from "@shopify/polaris-icons";
import { useState } from "react";
import { usePartnerUp } from "../../providers/PartnerUpStoreProvider";
// import BucketButton from "./BucketButton";
import { getBestAvatar, getCountry, shortenNumber } from "../../utils";

export default function AddCreatorModal({ open, onClose }) {
  const { getModashProfile, downloadsLimitReached, saveCreator, store } = usePartnerUp()

  const [changingBucket, setChangingBucket] = useState(false)
  const [saving, setSaving] = useState(false)
  const [searching, setSearching] = useState(false)
  const [stage, setStage] = useState(1)
  const [profile, setProfile] = useState(null)
  const [localCreator, setLocalCreator] = useState({
    id: 'new',
    name: '',
    platform: 'instagram',
    handle: '',
    email: '',
    buckets: []
  });

  const stage1 = (
    <Modal.Section>
      <BlockStack gap="300">
        <InlineGrid columns="2" gap="300">
          <Select label="Platform" value={localCreator.platform} options={[
            {
              label: (
                <InlineStack gap="100">
                  <InlineStack>
                    <Icon source={LogoInstagramIcon} />
                  </InlineStack>
                  <Text>Instagram</Text>
                </InlineStack>
              ),
              value: 'instagram'
            },
            {
              label: (
                <InlineStack gap="100">
                  <InlineStack>
                    <Icon source={LogoTiktokIcon} />
                  </InlineStack>
                  <Text>TikTok</Text>
                </InlineStack>
              ),
              value: 'tiktok'
            },
            {
              label: (
                <InlineStack gap="100">
                  <InlineStack>
                    <Icon source={LogoYoutubeIcon} />
                  </InlineStack>
                  <Text>YouTube</Text>
                </InlineStack>
              ),
              value: 'youtube'
            },
          ]} onChange={platform => setLocalCreator({ ...localCreator, platform })} />
          <TextField label="Handle" prefix="@" value={localCreator.handle} onChange={handle => setLocalCreator({ ...localCreator, handle })} />
        </InlineGrid>
      </BlockStack>
    </Modal.Section>
  )
  const scrapedCreator = localCreator?.profile?.profile
  console.log('localCreator', localCreator)
  const stage2 = (
    <BlockStack gap="500">
      <Modal.Section>
        <InlineGrid columns="1fr 2fr" gap="300" alignItems="center">
          <Card>
            <BlockStack inlineAlign="center" align="center" gap="100" blockAlign="center">
              <img shape="square" name={localCreator?.name} initials={localCreator?.name?.[0]} src={getBestAvatar(localCreator)} width="50%" />
              <BlockStack gap="2">
                <InlineStack align="center" blockAlign="center">
                  {
                    localCreator?.platform === 'tiktok' ? <Icon source={LogoTiktokIcon} /> : localCreator?.platform === 'youtube' ? <Icon source={LogoYoutubeIcon} /> : <Icon source={LogoInstagramIcon} />
                  }
                  <BlockStack inlineAlign="center">
                    {
                      /*
    scrapedCreator ? (
    <Text variant="headingMd">{localCreator?.name}</Text>
    ) : <TextField label="Name" value={localCreator?.name} onChange={name => setLocalCreator({ ...localCreator, name })} />
    */
                    }
                    <Link removeUnderline url={`https://${localCreator?.platform}/${localCreator?.handle}`}>
                      @{localCreator?.handle}
                    </Link>
                  </BlockStack>
                </InlineStack>
              </BlockStack>
              <InlineStack align="center" gap="100">
                {
                  localCreator?.profile?.country ? (
                    <Tag padding="1">
                      <Text>{getCountry(localCreator?.profile?.country)}</Text>
                    </Tag>
                  ) : null
                }
                {
                  localCreator?.profile?.gender ? (
                    <Tag padding="1">
                      <Text>{localCreator?.profile?.gender}</Text>
                    </Tag>
                  ) : null
                }
                {
                  localCreator?.profile?.ageGroup ? (
                    <Tag padding="1">
                      <Text>{localCreator?.profile?.ageGroup}</Text>
                    </Tag>
                  ) : null
                }
              </InlineStack>
            </BlockStack>
          </Card>
          <BlockStack gap="300">
            <TextField prefix="Name" value={localCreator?.name} onChange={name => setLocalCreator({ ...localCreator, name })} />
            <TextField prefix="Email" value={localCreator?.email} onChange={email => setLocalCreator({ ...localCreator, email })} />
          </BlockStack>
        </InlineGrid>
      </Modal.Section>
      {
        scrapedCreator ? (
          <BlockStack gap="200">
            <InlineGrid columns="3" gap="300">
              <Card>
                <BlockStack inlineAlign="start" gap="2">
                  <InlineStack>
                    <Icon source={PersonIcon} />
                  </InlineStack>
                  <BlockStack gap="100">
                    <Text>Followers</Text>
                    <Text variant="headingMd">{shortenNumber(localCreator?.profile?.profile?.followers)}</Text>
                  </BlockStack>
                </BlockStack>
              </Card>
              <Card>
                <BlockStack inlineAlign="start" gap="2">
                  <InlineStack>
                    <Icon source={SmileyJoyIcon} />
                  </InlineStack>
                  <BlockStack gap="100">
                    <Text>Engagement</Text>
                    <Text variant="headingMd">{(localCreator?.profile?.profile?.engagementRate * 100)?.toFixed(2)}%</Text>
                  </BlockStack>
                </BlockStack>
              </Card>
              {
                localCreator?.platform === 'instagram' ? (
                  <Card>
                    <BlockStack inlineAlign="start" gap="2">
                      <InlineStack>
                        <Icon source={DiscountIcon} />
                      </InlineStack>
                      <BlockStack gap="100">
                        <Text>Fake</Text>
                        <Text variant="headingMd">{((1 - localCreator?.profile?.audience?.credibility) * 100)?.toFixed(2)}%</Text>
                      </BlockStack>
                    </BlockStack>
                  </Card>
                ) : (
                  <Card>
                    <BlockStack inlineAlign="start" gap="2">
                      <InlineStack gap="space-between">
                        <InlineStack>
                          <Icon source={PlayIcon} />
                        </InlineStack>
                      </InlineStack>
                      <BlockStack gap="100">
                        <Text>Avg Views</Text>
                        <Text variant="headingMd">{shortenNumber(localCreator?.profile?.profile?.averageViews)}</Text>
                      </BlockStack>
                    </BlockStack>
                  </Card>
                )
              }
            </InlineGrid>
            <Banner title="Save Profile to See All Stats" status="info" />
          </BlockStack>
        ) : null
      }
      <InlineStack align="center">
        {
          /*
          <BucketButton callback={(buckets) => {
            setLocalCreator({ ...localCreator, buckets })
          }} creator={localCreator} changeBucketIndex={changingBucket} setChangeBucketIndex={setChangingBucket} orientation="horizontal" />
            */
        }
      </InlineStack>
    </BlockStack>
  )

  return (
    <Modal title="Add New Creator" open={open} onClose={() => {
      onClose()
      setLocalCreator({
        id: 'new',
        name: '',
        platform: 'instagram',
        handle: '',
        email: '',
        scrape: true,
        buckets: []
      })
      setStage(1)
    }} secondaryActions={stage === 1 ? [
      {
        content: 'Add Manually',
        disabled: !localCreator?.handle,
        onAction: () => setStage(2)
      }
    ] : [
      {
        content: 'Back',
        onAction: () => setStage(1)
      }
    ]} primaryAction={{
      content: stage === 1 ? 'Get Profile' : 'Save',
      loading: searching || saving,
      disabled: !localCreator?.handle || downloadsLimitReached,
      onAction: async () => {
        if (stage === 1) {
          try {
            setSearching(true)
            const { data: res } = await getModashProfile({
              profileID: localCreator?.handle,
              platform: localCreator?.platform,
              shop: store.id
            })
            const email = res?.profile?.contacts?.find(e => e?.type === 'email')?.email?.value || localCreator?.email
            setLocalCreator({ ...localCreator, ...res, email, name: res.profile?.profile?.fullname })
            setStage(2)
          } catch (e) {
            console.error(e)
            alert('Failed to get profile')
          } finally {
            setSearching(false)
          }
        } else {
          try {
            setSaving(true)
            const profileID = await saveCreator(localCreator)
            // setOpenCreator(profileID)
            onClose()
          } catch (e) {
            console.error(e)
            alert('Failed to save creator')
          } finally {
            setSaving(false)
          }
        }
      }
    }}>
      <Modal.Section>
        {stage === 1 ? stage1 : stage2}
      </Modal.Section>
    </Modal>
  )
}
